import React from "react";
import Card from "react-bootstrap/Card";
import { Link } from "react-router-dom";

const SoarCard = (props) => {
  const openRecord = () => {
    const url = process.env.REACT_APP_ORG + props.path;
    window.open(url, "soar");
  };

  return (
    <Card className="card-safy">
      <Card.Header
        className={props.className ? props.className : "bg-safy1-1 p-1 ps-4"}
        style={{ color: "white" }}
      >
        <div className="row">
          <div className="col-10">
            {props.linkState ? (
              <Link
                title={props.title}
                to={props.link}
                state={props.linkState}
                className="text-white"
              >
                {props.title}
              </Link>
            ) : props.link ? (
              <a className="text-white" href={props.link}>
                {props.title}
              </a>
            ) : (
              props.title
            )}
          </div>
          <div className="col-2">
            <div className="float-end">
              {props.showEdit ? (
                <i
                  title="Edit"
                  className="fas fa-pen float-end p-1"
                  onClick={props.showEdit}
                  style={{ color: "#FFFFFF" }}
                ></i>
              ) : (
                <i
                  title="Edit"
                  onClick={() => openRecord()}
                  className="fas fa-pen float-end p-1"
                  style={{ color: "#FFFFFF" }}
                ></i>
              )}
              {props.reportlink && (
                <i
                  title="Report"
                  onClick={() => window.open(props.reportlink, "IR Report")}
                  className="fas fa-print float-end p-1"
                  style={{ color: "#FFFFFF" }}
                ></i>
              )}
            </div>
          </div>
        </div>
      </Card.Header>
      {props.body && (
        <Card.Body className={props.cardBodyBg || "card-body-safy"}>
          {props.body}
        </Card.Body>
      )}
      {props.footer && (
        <Card.Footer style={{ backgroundColor: "#BBB" }}>
          {props.footer}
        </Card.Footer>
      )}
    </Card>
  );
};

export default SoarCard;
